// Standard paper size dimensions for document scanning
// Dimensions are in pixels at 150 DPI for optimal PDF quality

export interface PaperSize {
  width: number;
  height: number;
  label: string;
}

// Standard paper sizes at 150 DPI
// A4: 210mm × 297mm → 1240px × 1754px
// Letter: 8.5in × 11in → 1275px × 1650px
// Legal: 8.5in × 14in → 1275px × 2100px
export const PAPER_SIZES = {
  A4: {
    width: 1240,
    height: 1754,
    label: 'A4 (210mm × 297mm)',
  },
  LETTER: {
    width: 1275,
    height: 1650,
    label: 'Letter (8.5" × 11")',
  },
  LEGAL: {
    width: 1275,
    height: 2100,
    label: 'Legal (8.5" × 14")',
  },
  AUTO: {
    width: 0, // Will be auto-detected
    height: 0,
    label: 'Auto-detect',
  },
} as const;

export type PaperSizeKey = keyof typeof PAPER_SIZES;

export const getPaperSize = (key: PaperSizeKey): PaperSize => {
  return PAPER_SIZES[key];
};

export const DEFAULT_PAPER_SIZE: PaperSizeKey = 'A4';
